import { Link as RouterLink } from '@tanstack/react-router';
import { type CSSProperties, Fragment, type ReactNode } from 'react';

export interface AppBarBreadCrumbCrumb {
  label: string;
  path: string;
}

export interface AppBarBreadCrumbProps {
  breadCrumbs: Array<AppBarBreadCrumbCrumb>;
  buttonRight?: ReactNode;
  returnLabelText?: string | null;
  returnLabelLink?: string | null;
}

const WRAPPER: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  height: 50,
  paddingLeft: 12,
  flex: 1,
  minWidth: 0,
};

const RIGHT: CSSProperties = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 16,
};

const PRIMARY_LINK: CSSProperties = {
  color: 'white',
  fontSize: '1.5rem',
  letterSpacing: 0,
  fontWeight: 400,
  textTransform: 'none',
  textDecoration: 'none',
};

const END_CRUMB: CSSProperties = { ...PRIMARY_LINK, fontWeight: 700 };

const RETURN_LINK: CSSProperties = {
  cursor: 'pointer',
  display: 'inline',
  color: 'white',
  marginRight: 15,
  fontSize: '1.5rem',
  fontWeight: 700,
  textDecoration: 'none',
};

const OUTER: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
};

export const AppBarBreadCrumb = ({
  breadCrumbs,
  buttonRight = null,
  returnLabelText = null,
  returnLabelLink = null,
}: AppBarBreadCrumbProps) => {
  const { label: returnLabel, path: returnPath } = breadCrumbs[0];
  const lastIdx = breadCrumbs.length - 1;

  return (
    <div style={OUTER}>
      <div style={WRAPPER}>
        {breadCrumbs.map(({ label, path }, idx) =>
          idx === lastIdx ? (
            <span key={path} style={END_CRUMB}>
              {label}
            </span>
          ) : (
            <Fragment key={path}>
              <RouterLink to={path} style={PRIMARY_LINK}>
                {label}
              </RouterLink>
              <span style={{ color: 'white' }}>/</span>
            </Fragment>
          )
        )}
      </div>

      <div style={RIGHT}>
        {buttonRight}
        <RouterLink to={returnLabelLink || returnPath} style={RETURN_LINK}>
          {`Back to ${returnLabelText || returnLabel}`}
        </RouterLink>
      </div>
    </div>
  );
};

export default AppBarBreadCrumb;
